import { Col, DatePicker, Input, InputNumber, Row } from "antd";
import moment from "moment";
import * as React from "react";

export interface IGeneralInformationProps {
  budget: number | undefined;
  handleBudgetChange: (budget: number) => void;
  homepage: string | undefined;
  handleHomePageChange: (homepage: string) => void;
  runtime: number | undefined;
  handleRuntimeChange: (runtime: number) => void;
  castSize: number | undefined;
  handleCastSizeChange: (castSize: number) => void;
  crewSize: number | undefined;
  handleCrewSizeChange: (crewSize: number) => void;
  releaseDate: string | undefined;
  handleReleaseDateChange: (releaseDate: string) => void;
}

export default class GeneralInformation extends React.Component<
  IGeneralInformationProps,
  {}
> {
  constructor(props: IGeneralInformationProps) {
    super(props);

    this.state = {};
    this.handleHomePageOnChange = this.handleHomePageOnChange.bind(this);
    this.handleReleaseDateOnChange = this.handleReleaseDateOnChange.bind(this);
  }

  public render() {
    return (
      <div>
        <Row type="flex" justify="center">
          <Col span={6}>Budget</Col>
          <Col span={6}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={this.props.handleBudgetChange}
              defaultValue={this.props.budget}
            />
          </Col>
        </Row>
        <br />
        <Row type="flex" justify="center">
          <Col span={6}>Runtime (minutes)</Col>
          <Col span={6}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={this.props.handleRuntimeChange}
              defaultValue={this.props.runtime}
            />
          </Col>
        </Row>
        <br />
        <Row type="flex" justify="center">
          <Col span={6}>Cast Size</Col>
          <Col span={6}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={this.props.handleCastSizeChange}
              defaultValue={this.props.castSize}
            />
          </Col>
        </Row>
        <br />

        <Row type="flex" justify="center">
          <Col span={6}>Crew Size</Col>
          <Col span={6}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={this.props.handleCrewSizeChange}
              defaultValue={this.props.crewSize}
            />
          </Col>
        </Row>
        <br />
        <Row type="flex" justify="center">
          <Col span={6}>Release Date</Col>
          <Col span={6}>
            <DatePicker
              style={{ width: "100%" }}
              onChange={this.handleReleaseDateOnChange}
              defaultValue={moment(this.props.releaseDate)}
            />
          </Col>
        </Row>
        <br />
        <Row type="flex" justify="center">
          <Col span={6}>HomePage</Col>
          <Col span={6}>
            <Input
              style={{ width: "100%" }}
              onChange={this.handleHomePageOnChange}
              value={this.props.homepage}
            />
          </Col>
        </Row>
      </div>
    );
  }

  private handleReleaseDateOnChange(date: moment.Moment, dateString: string) {
    this.props.handleReleaseDateChange(dateString);
  }

  private handleHomePageOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.handleHomePageChange(e.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/GeneralInformation.tsx